export default [
	{
		key: 'reconcile_date',
		align: 'center',
		title: 'Reconcile At',
		scopedSlots: {customRender: 'reconcile_date'}
	}, {
		dataIndex: 'created_at',
		key: 'created_at',
		title: 'Created At',
		align: 'center',
		scopedSlots: {customRender: 'datetime'}
	}, {
		dataIndex: 'updated_at',
		key: 'updated_at',
		title: 'Updated At',
		align: 'center',
		scopedSlots: {customRender: 'updated_at'}
	}, {
		dataIndex: 'type',
		key: 'type',
		align: 'center',
		title: 'Tipe',
		scopedSlots: {customRender: 'type'}
	}, {
		key: 'disbursementable',
		align: 'center',
		title: 'Biller / Sponsor',
		scopedSlots: {customRender: 'disbursementable'}
	}, {
		key: 'account',
		title: 'Account Number',
		scopedSlots: {customRender: 'account'}
	}, {
		dataIndex: 'amount',
		key: 'amount',
		align: 'center',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		key: 'remark',
		title: 'Remark',
		scopedSlots: {customRender: 'remark'}
	}, {
		dataIndex: 'ref_number',
		key: 'ref_number',
		align: 'center',
		title: 'Ref ID',
		scopedSlots: {customRender: 'ref_number'}
	}, {
		dataIndex: 'response_code',
		key: 'response_code',
		align: 'center',
		title: 'RC',
		scopedSlots: {customRender: 'response_code'}
	}, {
		dataIndex: 'status',
		key: 'status',
		align: 'center',
		title: 'Status',
		scopedSlots: {customRender: 'status'}
	}, {
		title: '',
		key: 'action',
		scopedSlots: {customRender: 'action'}
	}
]
